import { useMemo } from 'react';

import useChartOptions from '@/components/Chart/hooks/options/useChartOptions';
import useForwardCurveOptions from '@/components/Chart/hooks/options/useForwardCurveOptions';
import useForwardCurveChartSeries from '@/components/Chart/hooks/useForwardCurveChartSeries';
import type { PreviewChartProps } from '@/features/DataHub/constants/charts';
import { CHART_HEIGHT } from '@/features/DataHub/constants/charts';
import { DATAHUB_DEFAULT_GROUP } from '@/features/DataHub/constants/const';
import type { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

import PreviewChartLayout from './PreviewChartLayout';
import usePreviewOptions from './usePreviewOptions';

const PreviewFwdCurveChart = ({ symbols, symbolLimit }: PreviewChartProps) => {
  const templateChartSeries: TemplateChartSeries[] = useMemo(() => {
    return Array.from(symbols)
      .slice(0, symbolLimit || 3)
      .map(symbol => ({
        settings: { type: 'line' as const },
        symbol: {
          group: DATAHUB_DEFAULT_GROUP,
          key: {
            Code: symbol.Code,
            PeriodType: symbol.PeriodType,
            Period: symbol.Period,
            TimeRef: symbol.TimeRef
          },
          transactionDate: symbol.transactionDate
        }
      }));
  }, [symbols, symbolLimit]);

  const { loading, error, chartSeries } = useForwardCurveChartSeries(templateChartSeries);

  const { createOptions } = useForwardCurveOptions(CHART_HEIGHT);
  const { options: baseOptions } = useChartOptions(chartSeries, createOptions);
  const options = usePreviewOptions(baseOptions);

  return (
    <PreviewChartLayout
      chartSeries={chartSeries}
      chartType='forwardSimple'
      error={error}
      loading={loading}
      options={options}
    />
  );
};

export default PreviewFwdCurveChart;
